import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { UserDetailsComp } from './userdetails';
import { AddNewUser, GetUserList, UpdateUser } from '../../models/user';
import { pnkstore } from '../../stores/pnk-store';
import { useUserStore } from '../../stores/user-store';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { GetProfileList } from '../../models/profile';
import { GetCitiesList, GetDistrictList, GetStatesList } from '../../models/project';
import axios from 'axios';
import AppUtils from '../../apputils';

export const UserDetails = () => {
    const userData = useUserStore;
    const [getUserDetails, setGetUserDetails] = useState(false);
    const [getStateList, setGetStateList] = useState(true);
    const [stateListData, setStateListData] = useState([]);
    const [getCityList, setGetCityList] = useState(false);
    const [cityListData, setCityListData] = useState([]);
    const [getProfileList, setGetProfileList] = useState(true);
    const [getUserList, setGetUserList] = useState(true);
    const [profileList, setProfileList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [UserFormData, setUserFormData] = useState({
        'ddlUserStatus': 0,
        'txtDol': new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10).replace('T', ' '),
    });
    const [mode, setMode] = useState('add');
    const [userObj, setUserObj] = useState('');
    const [addUser, setAddUser] = useState(false);
    const [editUser, setEditUser] = useState(false);
    const [fileInfo, setFileInfo] = useState({});
    const [uploadData, setUploadData] = useState(false);
    const [uploadCancelCheque, setUploadCancelCheque] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();


    const state = {
        getProfileList: getProfileList,
        profileList: profileList,
        userList: userList,
        mode: mode,
        addUser: addUser,
        editUser: editUser,
        uploadData: uploadData,
        uploadCancelCheque: uploadCancelCheque,
    }

    useEffect(() => {
        let user_id = params.user_id;
        if (user_id != undefined && user_id != null && user_id != '') {
            // alert(user_id);
            setMode('edit');
            setUserFormData((prev) => ({ ...prev, ['txtUserId']: user_id }));
            setGetUserDetails(true);
        }
    }, []);

    const HandleInputs = (e, name) => {
        let value = '';

        if (name === 'txtDol') {
            value = e.$d;
            value = new Date(new Date(value).getTime() - (new Date(value).getTimezoneOffset() * 60000)).toISOString().substr(0, 10).replace('T', ' ')
        }
        else {
            value = e.target.value
        }


        if (name === 'txtUserMobile' || name === 'txtUserAltMobile' || name === 'txtUserPincode' || name === 'txtUserBankAccount' || name === 'txtUserContact1Number' || name === 'txtUserContact1AltNumber' || name === 'txtUserContact2Number' || name === 'txtUserContact2AltNumber') {
            value = value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');
            setAddUser(false)
        }

        if (name == 'txtUserChequeFile') {
            console.log(e.target.files[0]);
            setFileInfo(e.target.files[0]);
        }
        else {
            setUserFormData((prev) => ({ ...prev, [name]: value }));
        }

        if (name == 'ddlUserState') {
            setGetCityList(true);
        }


    }


    const HandleStateListResponse = (res) => {
        //  console.log(res.data.statelistresponse.rows);
        if (res != false) {
            setStateListData(res.data.statelistresponse.rows);
        }
        else {
            setStateListData([]);
        }
        setGetStateList(false)
    }


    const HandleCityListResponse = (res) => {
        if (res != false) {
            let data = res.data.districtlistresponse.rows;
            setCityListData(data);
        }
        else {
            setCityListData([]);
        }

        setGetCityList(false);
    }


    const isValidIFSC = (ifsc) => {
        const regex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
        return regex.test(ifsc.toUpperCase());
    }



    const AddUser = () => {
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

        if (UserFormData.txtUserName === undefined || UserFormData.txtUserName === null || UserFormData.txtUserName.trim() === '') {
            setUserFormData((prev) => ({ ...prev, ['txtUserNameErr']: 'Please Enter User Name' }));
            return false;
        }
        else {
            setUserFormData((prev) => ({ ...prev, ['txtUserNameErr']: '' }));
        }

        if (UserFormData.txtUserMobile === undefined || UserFormData.txtUserMobile === null || UserFormData.txtUserMobile.trim() === '') {
            setUserFormData((prev) => ({ ...prev, ['txtUserMobileErr']: 'Please Enter User Mobile' }));
            return false;
        }
        else {
            setUserFormData((prev) => ({ ...prev, ['txtUserMobileErr']: '' }));
        }

        if (UserFormData.txtUserMobile.length >= 10 && UserFormData.txtUserMobile.length < 15) {
            setUserFormData((prev) => ({ ...prev, ['txtUserMobileErr']: '' }));
        }
        else {
            setUserFormData((prev) => ({ ...prev, ['txtUserMobileErr']: 'Please Enter Valid Mobile' }));
            return false;

        }

        if (UserFormData.txtUserEmail === undefined || UserFormData.txtUserEmail === null || UserFormData.txtUserEmail.trim() === '') {
            setUserFormData((prev) => ({ ...prev, ['txtUserEmailErr']: 'Please Enter User Email' }));
            return false;
        }
        else {
            setUserFormData((prev) => ({ ...prev, ['txtUserEmailErr']: '' }));
        }

        if (!UserFormData.txtUserEmail.match(validRegex)) {
            setUserFormData((prev) => ({ ...prev, ['txtUserEmailErr']: 'Please Enter Valid Email' }));
            return false;
        }
        else {
            setUserFormData((prev) => ({ ...prev, ['txtUserEmailErr']: '' }));
        }


        if (UserFormData.ddlUserType === undefined || UserFormData.ddlUserType === null || UserFormData.ddlUserType.trim() === '') {
            setUserFormData((prev) => ({ ...prev, ['ddlUserTypeErr']: 'Please Select User Profile' }));
            return false;
        }
        else {
            setUserFormData((prev) => ({ ...prev, ['ddlUserTypeErr']: '' }));
        }

        if (UserFormData.ddlReportingName === undefined || UserFormData.ddlReportingName === null || UserFormData.ddlReportingName.trim() === '') {
            setUserFormData((prev) => ({ ...prev, ['ddlReportingNameErr']: 'Please Select Reporting User' }));
            return false;
        }
        else {
            setUserFormData((prev) => ({ ...prev, ['ddlReportingNameErr']: '' }));
        }


        let profile_id_index = profileList.findIndex((item) => item.profile_name == UserFormData.ddlUserType);
        let profile_id = '';

        if (profile_id_index > -1) {
            profile_id = profileList[profile_id_index]._id;
        }

        setUserFormData((prev) => ({ ...prev, ['txtUserProfileId']: profile_id }));




        if (mode == 'add') {
            //  alert('aaaa');
            setAddUser(true);
        }
        else {
            console.log('zzzzzzzzzzzz')
            console.log(UserFormData);
            console.log('zzzzzzzzzzzz')
            setEditUser(true);
        }
    }

    const NavigateTo = (route) => {
        navigate('/' + route);
    }

    const HandleGetProfilesListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res);
            let profileListData = res.data.profilelistresponse.rows
            setProfileList(profileListData);
        }
        else {
            setProfileList([]);
        }
        setGetProfileList(false);
    }

    const HandleGetUserListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res);
            let userListData = res.data.userlistresponse.rows
            setUserList(userListData);
        }
        else {
            setUserList([]);
        }
        setGetProfileList(false);
    }

    const AddNewUserResponse = (res) => {
        // alert('pppp');
        // console.log('qqqqqqqqqqqqqqqqqqqq');
        // console.log(res);
        // console.log(pnkstore.error);
        if (res != false && res != 'error') {
            setUserObj({});
            NavigateTo('users');
        }
        else {
            console.log(res);
            // alert('ppppp');
        }

        setAddUser(false);
        //setEditUser(false);
    }

    const UpdateUserResponse = (res) => {
        if (res != false && res != 'error') {
            // setUserObj({});
            // NavigateTo('users');
            AppUtils.ShowMsg(res.data.userupdateresponse.message.value, 'success');
        }
        else {
            console.log(res);
            // alert('ppppp');
        }

        setEditUser(false);
    }

    const UploadData = (fieldName) => {
        if (fieldName === 'txtUserChequeFile') {
            setUploadCancelCheque(true);
        }
        UploadFile(fileInfo, fieldName);
    }

    const UploadFile = (file, fieldName) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('fileName', file.name);
        formData.append('destination', 'application/public/uploads/users');

        axios.post('http://localhost:5000/api/fileupload.json', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(function (response) {
                console.log(response.data.fileName);
                setUploadCancelCheque(false);
                setUserFormData((prev) => ({ ...prev, [fieldName]: response.data.fileName }));
            })
            .catch(function (error) {
                console.log(error);
                // setShowAlert(true);
                // setAlertMsg('Please Select Correct File');
                // setAlertType('error');
            });
    }


    const BindUserDetails = (user_data) => {


        console.log(user_data);

        setUserFormData((prev) => ({ ...prev, ['txtUserName']: user_data.user_full_name }));
        setUserFormData((prev) => ({ ...prev, ['txtUserMobile']: user_data.user_mobile }));
        setUserFormData((prev) => ({ ...prev, ['txtUserAltMobile']: user_data.user_alt_mobile }));
        setUserFormData((prev) => ({ ...prev, ['txtUserEmail']: user_data.user_email }));
        setUserFormData((prev) => ({ ...prev, ['txtUserAltEmail']: user_data.user_alt_email }));
        setUserFormData((prev) => ({ ...prev, ['ddlUserType']: user_data.user_profile_name }));
        setUserFormData((prev) => ({ ...prev, ['ddlReportingName']: user_data.user_reporting_name }));

        setUserFormData((prev) => ({ ...prev, ['ddlUserStatus']: user_data.user_status }));
        if (user_data.user_status === 0) {
            setUserFormData((prev) => ({ ...prev, ['txtDol']: user_data.user_dol }));
        }
    }

    const HandleGetUserDetailsSuccessResponse = (res) => {


        console.log(res);

        if (res !== false) {
            BindUserDetails(res.data.userlistresponse.rows[0]);
        }
        else {
            //  show error msg
        }

        setGetUserDetails(false)
    }



    return (
        <Box>
            <UserDetailsComp
                stateListData={stateListData}
                UserFormData={UserFormData}
                mystate={state}
                HandleInputs={HandleInputs}
                NavigateTo={NavigateTo}
                AddUser={AddUser}
                cityListData={cityListData}
                UploadData={UploadData}
            />
            {((getStateList === true) ? GetStatesList(pnkstore, userData.getState().token, HandleStateListResponse) : "")}
            {((getCityList === true) ? GetDistrictList(pnkstore, UserFormData.ddlUserState, userData.getState().token, HandleCityListResponse) : "")}
            {((addUser === true) ? AddNewUser(pnkstore, UserFormData, userData.getState().token, AddNewUserResponse) : "")}
            {((editUser === true) ? UpdateUser(pnkstore, UserFormData, userData.getState().token, UpdateUserResponse) : "")}
            {((getProfileList === true) ? GetProfileList(pnkstore, {}, userData.getState().token, HandleGetProfilesListSuccessResponse) : '')}
            {((getUserList === true) ? GetUserList(pnkstore, {}, userData.getState().token, HandleGetUserListSuccessResponse) : '')}
            {((getUserDetails === true) ? GetUserList(pnkstore, UserFormData, userData.getState().token, HandleGetUserDetailsSuccessResponse) : '')}
        </Box>
    )
}